import React from 'react';

import colors from './images/colors.png';
import colors2x from './images/colors@2x.png';

export default function UsedColors() {
  return <img alt="Colors used" src={colors} srcSet={`${colors2x} 2x`} />;
}
